import {UIUrlParameterNames} from './UIUrlController'

export abstract class UIManagerEvents {
    abstract createClickedJoinRoomCallback(gameId: string): Promise<void>
    abstract isSceneLobby(): boolean
    abstract isSceneGame(): boolean
    abstract leaveRoomAndJoinRoom(roomId: string)
    abstract handleUrlRedirectViaParameters(parameter: UIUrlParameterNames, parameterValue: any)
    abstract premiumMembershipCheckAction()
    abstract shareImage(title: string | undefined, text: string | undefined, link: string | undefined, imageFile: File | undefined, imageSrc: string | undefined)
}
